var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconFilter = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  preserveAspectRatio: "none",
  overflow: "visible",
  style: {
    display: "block"
  },
  width: 17.5,
  height: 12.5,
  viewBox: "0 0 17.5 12.5",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "layer1"
}, /*#__PURE__*/React.createElement("path", {
  id: "path6012",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.875 0C10.3705 0 9.10528 1.07838 8.81348 2.5H0.625C0.279825 2.5 0 2.77982 0 3.125C0 3.47018 0.279825 3.75 0.625 3.75H8.81348C9.10528 5.17162 10.3705 6.25 11.875 6.25C13.3795 6.25 14.6447 5.17162 14.9365 3.75H16.875C17.2202 3.75 17.5 3.47018 17.5 3.125C17.5 2.77982 17.2202 2.5 16.875 2.5H14.9365C14.6447 1.07838 13.3795 0 11.875 0ZM11.875 1.25C12.9179 1.25 13.75 2.08208 13.75 3.125C13.75 4.16792 12.9179 5 11.875 5C10.8321 5 10 4.16792 10 3.125C10 2.08208 10.8321 1.25 11.875 1.25Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  id: "path6014",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.625 6.24998C4.12051 6.24998 2.85528 7.32837 2.56348 8.74998H0.625C0.279825 8.74998 0 9.02981 0 9.37498C0 9.72016 0.279825 9.99998 0.625 9.99998H2.56348C2.85528 11.4216 4.12051 12.5 5.625 12.5C7.12949 12.5 8.39472 11.4216 8.68652 9.99998H16.875C17.2202 9.99998 17.5 9.72016 17.5 9.37498C17.5 9.02981 17.2202 8.74998 16.875 8.74998H8.68652C8.39472 7.32837 7.12949 6.24998 5.625 6.24998ZM5.625 7.49998C6.66792 7.49998 7.5 8.33207 7.5 9.37498C7.5 10.4179 6.66792 11.25 5.625 11.25C4.58208 11.25 3.75 10.4179 3.75 9.37498C3.75 8.33207 4.58208 7.49998 5.625 7.49998Z",
  fill: "black"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconFilter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-filter.46ffe5b17a78e81444b6b1ac5bfb4311.svg";